import { render, staticRenderFns } from "./product-brief.vue?vue&type=template&id=acc16d8a&scoped=true&"
import script from "./product-brief.vue?vue&type=script&lang=js&"
export * from "./product-brief.vue?vue&type=script&lang=js&"
import style0 from "./product-brief.vue?vue&type=style&index=0&id=acc16d8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc16d8a",
  null
  
)

export default component.exports